import React from "react";
import { Table } from "antd";
import { format } from "date-fns";
import { WebApiModelsCustomListField } from "../../../Repository/eventbookyapi";
import { ColumnsType } from "antd/lib/table";
import { UiControlType } from "../../../Types/UiControlType";
import { excelSerialToDate, isExcelSerialDate } from "../../../Helpers/DateHelpers";

interface UploadCustomListItemPreviewTableProps {
    data: any[];
    fieldSettings: WebApiModelsCustomListField[];
    showMemberIdColumn?: boolean;
}

const UploadCustomListItemPreviewTable: React.FC<UploadCustomListItemPreviewTableProps> = ({
    data,
    fieldSettings,
    showMemberIdColumn,
}) => {
    const memberIdColumn = showMemberIdColumn
        ? [{
            title: "MedlemId",
            dataIndex: (data[0]?.memberId !== undefined ? "memberId" : "medlemsid"),
            key: "memberId_preview",
        }]
        : [];

    const columns: ColumnsType<any> = [
        ...memberIdColumn,
        ...fieldSettings
            .filter(f => f.nameAdmin)
            .map(f => ({
                title: f.nameAdmin,
                dataIndex: f.nameAdmin as string,
                key: f.id !== undefined && f.id !== null ? f.id.toString() : f.nameAdmin || "",
                render: (value: any) => {
                    // Handle date fields with Excel serial numbers
                    if (f.uiControl === UiControlType.Date && value != null && value !== "") {
                        if (isExcelSerialDate(value)) {
                            const date = excelSerialToDate(value);
                            return date ? format(date, "yyyy-MM-dd") : value;
                        }
                    }
                    return value;
                }
            }))
    ];

    return (
        <Table
            dataSource={data}
            columns={columns}
            rowKey={(_, idx) => idx!.toString()}
            pagination={false}
            size="small"
        />
    );
};

export default UploadCustomListItemPreviewTable;